import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 126,
  height: 176,
  x: 0,
  y: 0,
  list: [
    {
      id: 'b99ca80f-f264-4409-b075-daa92acaf166',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: 'be1bfa51-470a-4dc3-9344-26cc1b14a6f5',
      type: 'Armature',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'b99ca80f-f264-4409-b075-daa92acaf166',
      data: '',
      animationName: 'animation',
      armatureName: 'Armature',
      dragonbonesName: 'special_card_melon',
      playOnStart: false,
      progress: 0,
      playTimes: 1
    }
  ],
  version: '1.0.x'
} as const;

export class BoomCardLayout {
  static raw = raw;
  root: PIXI.Container

  constructor() {
    populate(this, raw);
  }
}
